export default __webpack_public_path__ + "static/hero-bg-mob-6734cb02aaac0ae017ea9f657565ca47.png";